var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentsOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12745_1686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12745_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2999 25.5002C11.7999 25.5002 11.3749 25.3252 11.0249 24.9752C10.6749 24.6252 10.4999 24.2002 10.4999 23.7002V12.7372C10.4999 12.7125 10.5082 12.6835 10.5249 12.6502L9.2749 11.4002L10.3499 10.3252L29.8499 29.8502L28.7999 30.9252L23.3749 25.5002H12.2999ZM29.4999 26.6502L26.8499 24.0002H27.9999V12.3002C27.9999 12.2169 27.9709 12.1459 27.9129 12.0872C27.8542 12.0292 27.7832 12.0002 27.6999 12.0002H14.8499L13.3499 10.5002H27.6999C28.1999 10.5002 28.6249 10.6752 28.9749 11.0252C29.3249 11.3752 29.4999 11.8002 29.4999 12.3002V26.6502ZM12.2999 24.0002H21.8749L19.6249 21.7502H14.2499V20.2502H18.1249L16.6249 18.7502H14.2499V17.2502H15.1249L11.9999 14.1252V23.7002C11.9999 23.7835 12.0292 23.8542 12.0879 23.9122C12.1459 23.9709 12.2166 24.0002 12.2999 24.0002ZM24.5999 21.7502L23.0999 20.2502H25.7499V21.7502H24.5999ZM21.5999 18.7502L20.0999 17.2502H25.7499V18.7502H21.5999ZM18.5999 15.7502L17.0999 14.2502H25.7499V15.7502H18.5999Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsOff);
export default __webpack_public_path__ + "static/media/commentsOff.9043b20629b89c4fdc5e6b7f236a9db3.svg";
export { ForwardRef as ReactComponent };